export const MAIN_COVER_EVENTS = {
  SELECT_WEB_BUY_NOW_BANNER: "web_select_buy_now_banner",
  SELECT_WEB_PROMO_BANNER: "web_select_promo_banner",
  SELECT_WEB_WHOLESALE_BANNER: "web_select_wholesale_banner",
  SELECT_WEB_VIDEO_BANNER: "web_select_view_video_banner",
  SELECT_WEB_BANNER_ARROW: "web_select_buy_now_banner_arrow",
};
